var map = {
	"./abraco.svg": "8051",
	"./acupuntura.svg": "8a1b",
	"./alongamento.svg": "5af6",
	"./caminhar.svg": "faed",
	"./camomila.svg": "d3c4",
	"./cigarros.svg": "a451",
	"./distanciamento.svg": "6f08",
	"./dormir.svg": "d3c1",
	"./espreguica.svg": "8be4",
	"./estresse.svg": "79e3",
	"./fitness.svg": "3ac2",
	"./friends.svg": "f3a4",
	"./ioga.svg": "9f88",
	"./jardinagem.svg": "cc7a",
	"./lavanda.svg": "56d7",
	"./lazer.svg": "909e",
	"./lifestyle.svg": "5b2a",
	"./massagem.svg": "8e97",
	"./musica.svg": "110d",
	"./nocoffee.svg": "0a84",
	"./nosmoke.svg": "0349",
	"./nosugar.svg": "57a8",
	"./paisagem.svg": "932e",
	"./plantar.svg": "6048",
	"./poda.svg": "d993",
	"./pp.svg": "53fc",
	"./resenha.svg": "0111",
	"./respirar.svg": "5223",
	"./saudavel.svg": "3965",
	"./saude.svg": "3d85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8536";